import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    colors,
    DoubleChevronLeftIcon,
    DoubleChevronRightIcon
} from "@dotnet/telematics-design-system";

import ButtonDefault from "components/DesignComponents/ButtonDefault";
import {
    TOOLTIP_PLACEMENT,
    TOOLTIP_SIZES,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";

import { ToggleDrawerButtonProps } from "../types";

const ToggleDrawerButton = ({
    isdrawerOpen,
    onOpendrawer,
    onDrawerClose
}: ToggleDrawerButtonProps) => {
    const { t } = useTranslation();

    const { gray100, gray700 } = colors;

    return (
        <ButtonDefault
            onClick={isdrawerOpen ? onDrawerClose : onOpendrawer}
            className="navigation-item"
            css={css({
                cursor: "pointer",
                padding: "6px",

                "& > svg": {
                    color: gray700
                },

                "&:hover": {
                    backgroundColor: gray100
                }
            })}
        >
            {isdrawerOpen ? (
                <DoubleChevronLeftIcon />
            ) : (
                <TooltipGeneral
                    title={t("General##expand menu")}
                    placement={TOOLTIP_PLACEMENT.Right}
                    size={TOOLTIP_SIZES.Small}
                    disableTouchListener
                >
                    <div
                        css={css({
                            height: "24px",
                            color: gray700
                        })}
                    >
                        <DoubleChevronRightIcon />
                    </div>
                </TooltipGeneral>
            )}

            <span
                css={css({
                    marginLeft: "8px",
                    whiteSpace: "nowrap",
                    fontSize: "14px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    color: gray700
                })}
            >
                {t("General##collapse menu")}
            </span>
        </ButtonDefault>
    );
};

export default ToggleDrawerButton;
